module.exports = __webpack_public_path__ + "img/260.886de483.png";